import { useMutation } from "@tanstack/react-query"
import axios from "axios"

export const useUploadWhatsappMediaMutation = () => {
  return useMutation({
    mutationFn: async (file: FileList) => {
      const { data } = await axios.post(`/integrations/whatsapp/templates/media`, {
        file,
      })
      return data.data
    },
  })
}
